import { NetworkInformation } from '../NetworkStatusProvider.types';

type NavigatorWithConnection = Navigator & {
  connection?: NetworkInformation;
  mozConnection?: NetworkInformation;
  webkitConnection?: NetworkInformation;
};

export const getNetworkConnection = (): NetworkInformation | undefined => {
  if (typeof navigator === 'undefined') {
    return undefined;
  }

  const navigatorWithConnection = navigator as NavigatorWithConnection;

  return (
    navigatorWithConnection.connection ??
    navigatorWithConnection.mozConnection ??
    navigatorWithConnection.webkitConnection
  );
};

export const getIsOnline = (): boolean => {
  if (typeof navigator === 'undefined') {
    return true;
  }

  return navigator.onLine;
};
